export enum AdditionalOfferInteractionTypeEnum {
	PrematchAdditionalOffer = "PrematchAdditionalOffer",
	LiveAdditionalOffer = "LiveAdditionalOffer",
}
